import { Environments } from '../models';

/**
 * Get site environment (one of 'localhost' | 'dev' | 'stg' | 'prod')
 */
export const getEnvironment = (): Environments => {
  const environment = window.location.href.includes('localhost') // http://localhost:3000
    ? 'localhost'
    : window.location.href.includes('dev-admin.franklinst') // https://dev-admin.franklinst.com
    ? 'dev'
    : window.location.href.includes('stg-admin.franklinst') // https://stg-admin.franklinst.com
    ? 'stg'
    : 'prod';
  return environment;
};

/**
 * Get the header background color based on the environment
 */
export const getHeaderColor = (): string => {
  const environment = getEnvironment();
  
  switch (environment) {
    case 'localhost':
    case 'dev':
      return 'rgb(203, 232, 186)'; // Light green for dev
    case 'stg':
      return '#659DF2'; // Blue for staging
    case 'prod':
    default:
      return '#94A596'; // Olive for production (existing color)
  }
};

/**
 * Get the header text color based on the environment
 */
export const getHeaderTextColor = (): string => {
  const environment = getEnvironment();
  
  switch (environment) {
    case 'localhost':
    case 'dev':
      return '#123743'; // Dark text for light green background
    case 'stg':
    case 'prod':
    default:
      return '#ffffff'; // White text for blue/olive backgrounds
  }
};

/**
 * Get the environment label to display in the header
 * Returns null for production (no label shown)
 */
export const getEnvironmentLabel = (): string | null => {
  const environment = getEnvironment();
  
  switch (environment) {
    case 'localhost':
      return 'Localhost';
    case 'dev':
      return 'Development';
    case 'stg':
      return 'Staging';
    case 'prod':
    default:
      return null; // No label for production
  }
};
